import './customFilePlayerMenu.css';
import {useEffect, useState} from "react";

const CustomFilePlayerMenu = ({clickPosition, videoUrl, title, downloadUrl, downloading}) => {

    const [linkCopied, setLinkCopied] = useState(false);

    useEffect(() => {
        setLinkCopied(false);
    }, [clickPosition.x, clickPosition.y]);

    const handleGenerateVlcLink = () => {
        // generate a txt file with the videoUrl called title.m3u8
        const blob = new Blob([downloadUrl], {type: 'text/plain'});
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${title}.m3u8`;
        a.click();
        URL.revokeObjectURL(url);
    }

    const handleCopyLink = () => {
        navigator.clipboard.writeText(downloadUrl).then(() => {
        });
    }

    const handleDownloadFile = () => {
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.target = '_blank';
        link.click();
        link.remove();
    }

    return (
        <div className="custom-file-player-menu" style={{
            top: clickPosition.y,
            left: clickPosition.x,
        }}>
            <button className="custom-file-player-menu__button" onClick={handleGenerateVlcLink}>
                Archivo VLC&nbsp;
                <img src="https://upload.wikimedia.org/wikipedia/commons/3/38/VLC_icon.png" height={20}/>
            </button>
            <button className="custom-file-player-menu__button" onClick={handleCopyLink}>
                Copiar Link&nbsp;&nbsp;<i className="fa-solid fa-copy"></i>
            </button>
            <button className="custom-file-player-menu__button" onClick={handleDownloadFile}>
                Descargar&nbsp;&nbsp;
                {
                    downloading ?
                        <i className="fa-solid fa-spinner fa-spin"></i>
                        :
                        <i className="fa-solid fa-download"></i>
                }
            </button>
        </div>
    );
}

export default CustomFilePlayerMenu;
